export function packingMode(packingMode: any[]): string {
  let returnedString = '';
  if (!packingMode) return returnedString;
  returnedString = `${packingMode[0].unit1}\n${packingMode[0].unit2}`;
  packingMode.slice(1).forEach((packingModeItem: any) => {
    returnedString = `${returnedString}\n${packingModeItem.unit2}`;
  })
  return returnedString;
}